"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var createImpl = function (definition, contextName) {
    var actionCreatorPrototype = {};
    var reducers = {};
    Object.assign(actionCreatorPrototype, definition.actions);
    var _loop_1 = function (name_1) {
        var _a;
        var actionType = contextName + "_" + name_1;
        Object.assign(actionCreatorPrototype, (_a = {},
            _a[name_1] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return {
                    type: actionType,
                    args: args,
                    context: this.$context
                };
            },
            _a));
        reducers[actionType] = function (state, args, _context) {
            var _a;
            return (_a = definition.reducers)[name_1].apply(_a, [state].concat(args));
        };
    };
    for (var name_1 in definition.reducers) {
        _loop_1(name_1);
    }
    var _loop_2 = function (name_2) {
        var rec = createImpl(definition.combines[name_2], contextName + "_" + name_2);
        Object.defineProperty(actionCreatorPrototype, name_2, {
            get: function () {
                return rec.createActionCreator(this.$context);
            }
        });
        Object.assign(reducers, util_1.mapValues(rec.reducers, function (reducer) { return function (state, args, context) {
            var _a;
            if (state == null) {
                util_1.warn("Trying to perform action on slice " + name_2 + " of object that is null or undefined. The action will be ignored.");
                return state;
            }
            var resolved = state[name_2];
            var updated = reducer(resolved, args, context);
            return resolved === updated ? state : __assign({}, state, (_a = {}, _a[name_2] = updated, _a));
        }; }));
    };
    for (var name_2 in definition.combines) {
        _loop_2(name_2);
    }
    if (definition.list) {
        var listDefinition_1 = definition.list;
        var itemContextName_1 = listDefinition_1.contextName || contextName + "_item";
        var itemDefinition = listDefinition_1.of;
        var keyOf_1 = function (selector) {
            return typeof selector === "string" ? selector : listDefinition_1.key(selector);
        };
        var findIndex_1 = function (state, ctx) { return state.findIndex(function (i) { return keyOf_1(i) == ctx[itemContextName_1]; }); };
        var rec_1 = createImpl(itemDefinition, contextName + "_item");
        Object.assign(reducers, util_1.mapValues(rec_1.reducers, function (reducer) { return function (state, args, context) {
            if (!state) {
                util_1.warn("Trying to perform action on element " + context[itemContextName_1] + " of collection that is null or undefined. The action will be ignored.");
                return state;
            }
            var idx = findIndex_1(state, context);
            if (idx == -1) {
                util_1.warn("Trying to perform action on element " + context[itemContextName_1] + " of collection that does not contain it. The action will be ignored.");
                return state;
            }
            var resolved = state[idx];
            var updated = reducer(resolved, args, context);
            if (updated === resolved) {
                return state;
            }
            var result = state.slice();
            result.splice(idx, 1, updated);
            return result;
        }; }));
        Object.assign(actionCreatorPrototype, {
            $item: function (selector) {
                var _a;
                return rec_1.createActionCreator(__assign({}, this.$context, (_a = {}, _a[itemContextName_1] = keyOf_1(selector), _a)));
            }
        });
    }
    var createActionCreator = function (context) {
        var actionCreator = Object.create(actionCreatorPrototype);
        Object.assign(actionCreator, { $context: context });
        return actionCreator;
    };
    return { createActionCreator: createActionCreator, reducers: reducers };
};
exports.create = function (definition) {
    var res = createImpl(definition, 'action');
    return {
        Actions: res.createActionCreator({}),
        reduce: function (state, action) {
            if (state === void 0) { state = definition.default; }
            // const nonEmptyState = state == undefined ? createDefault(definition) : state;
            return res.reducers[action.type] ?
                res.reducers[action.type](state, action.args, action.context) :
                state;
        }
    };
};
